import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

const HK_TZ = "Asia/Hong_Kong";

export const intervalMapping: Record<
  "year" | "month" | "week" | "day",
  string
> = {
  year: "年",
  month: "月",
  week: "周",
  day: "日",
} as const;

export const queueStatusMap: Record<number, string> = {
  1: "pending",
  2: "active",
  3: "completed",
  4: "expired",
} as const;

export const TOMORROW = dayjs()
  .tz(HK_TZ)
  .add(1, "day")
  .startOf("day")
  .format("YYYY-MM-DD");

export const AWS_GLOBAL_IMAGE_URL =
  process.env.REACT_APP_AWS_GLOBAL_IMAGES_BUCKET_URL;
